import { createSelector } from '@ngrx/store';
import { getVirtualLocation } from '../getVirtualLocation';

export const getVirtualLocationFriendlyName = (locationNo: number) => createSelector(getVirtualLocation(locationNo), (virtualLocation) => virtualLocation?.LocationFriendlyName);
